<template>
  <component :is="iconName" />
</template>

<script lang="js">
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

// https://webpack.js.org/guides/dependency-management/#require-context
function getComponents() {
  const requireComponent = require.context(
    // Look for files in the current directory
    "../assets/",
    // Do not look in subdirectories
    false,
    // Only include "_base-" prefixed .vue files
    /[\w-]+\.svg$/
  );
  let components = [];

  // For each matching file name...
  requireComponent.keys().forEach((fileName) => {
    // Get the component config
    const componentConfig = requireComponent(fileName);
    // Get the PascalCase version of the component name
    const componentName = upperFirst(
      camelCase(
        fileName
          // Remove the "./_" from the beginning
          .replace(/^\.\/ic_/, "")
          // Remove the file extension from the end
          .replace(/\.\w+$/, "")
      )
    );
    // Globally register the component
    components[componentName] = componentConfig.default || componentConfig;
  });
  return Object.assign({}, components);
}

export default {
  name: "SvgIcon",
  data() {
    return {
      iconName: false,
    };
  },
  components: getComponents(),

  created() {
    let t = this;
    t.iconName = t.$slots.default[0].text;
  },
};
</script>


// WEBPACK FOOTER //
// ./src/components/SvgIcon.vue